module.exports = __webpack_public_path__ + "img/default_avatar.9c5e9831.png";